export class WarehouseMovementImportSuccess {
  constructor(public success?: boolean) {}

  clone() {
    return new WarehouseMovementImportSuccess(this.success);
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/warehouse-movement-impor-success.ts